import { Action, Location } from "history";

export const UPDATE_INSIGHTS_URL_HISTORY =
  "bonfire/history/UPDATE_INSIGHTS_URL_HISTORY";
export const UPDATE_MONITORING_URL_HISTORY =
  "bonfire/history/UPDATE_MONITORING_URL_HISTORY";
export const UPDATE_ACTIONS_URL_HISTORY =
  "bonfire/history/UPDATE_ACTIONS_URL_HISTORY";
export interface UpdateUrlHistoryAction {
  type:
    | typeof UPDATE_INSIGHTS_URL_HISTORY
    | typeof UPDATE_MONITORING_URL_HISTORY
    | typeof UPDATE_ACTIONS_URL_HISTORY;
  location: Location;
  updateType: Action;
}

declare module "history" {
  interface Location {
    /** Specific for Bonfire. Make sure you know what you are doing. */
    path: string;
  }
}
